
import React, { useState, useEffect } from "react"
import ReactPaginate from "react-paginate";
import { Col, Row } from "reactstrap"
import { Context } from "app-contexts/CommonContexts"
import { useContext } from "react"

export const LedgerSummary = ({ sortedLedgerUpdationList, ledgerSummaryPage, handleLedgerSummaryPageClick }) => {

    const {
        txnDecimalAmt
    } = useContext(Context);

    const grouped = sortedLedgerUpdationList.reduce((acc, curr) => {
        const key = `${curr.account}-${curr.remarks}`;
        if (!acc[key]) {
            acc[key] = {
                data: [],
                account: curr.account,
                debit: 0,
                credit: 0,
                doucmentNo: "",
                reference1: "",
                remarks: curr.remarks,
                reference2: ""
            };
        }
        acc[key].data.push(curr);
        acc[key].debit = acc[key].data.reduce((acc, curr) => acc + curr.debit, 0)
        acc[key].credit = acc[key].data.reduce((acc, curr) => acc + curr.credit, 0)
        return acc;
    }, []);


    const summerizedResult = Object.keys(grouped).map(key => {
        return grouped[key];
    });


    const iddexOfLastPostLedgerUpdation = ledgerSummaryPage * 10
    const iddexOfFirstPostLedgerUpdation = iddexOfLastPostLedgerUpdation - 10
    const currentDetailRowsLedgerUpdation = summerizedResult.slice(iddexOfFirstPostLedgerUpdation, iddexOfLastPostLedgerUpdation)

    return (
        <div>
            <Row>
                <Col sm={12} md={12} className="mb-4-sm">
                    <table className="custom-table table-bordered table-sm rounded">
                        <thead className='table-secondary'>
                            <tr>
                                <th colSpan={9} style={{ textAlign: 'center' , fontWeight: 'bold'  }}>
                                    Ledger Summary Details
                                </th>
                            </tr>
                            <tr style={{ height: '40px' }}>
                                <td style={{ fontWeight: 'bold' }}> # </td>
                                <td style={{ fontWeight: 'bold' }}>Account</td>
                                <td style={{ fontWeight: 'bold' }}>Remarks & A/C Description</td>
                                <td style={{ textAlign: "right", fontWeight: 'bold' }}>Debit</td>
                                <td style={{ textAlign: "right", fontWeight: 'bold' }}>Credit</td>
                            </tr>
                        </thead>
                        <tbody>
                            {currentDetailRowsLedgerUpdation.map((item, index) => (
                                <tr key={index}>
                                    <td>{iddexOfFirstPostLedgerUpdation + index + 1}</td>
                                    <td>{item.account}</td>
                                    <td>{item.remarks}</td>
                                    <td style={{ textAlign: "right" }}>{Math.abs(parseFloat(item.debit).toFixed(txnDecimalAmt)).toLocaleString(undefined, {
                                        maximumFractionDigits: txnDecimalAmt,
                                        minimumFractionDigits: 2,
                                    })}</td>
                                    <td style={{ textAlign: "right" }}>{Math.abs(parseFloat(item.credit).toFixed(txnDecimalAmt)).toLocaleString(undefined, {
                                        maximumFractionDigits: txnDecimalAmt,
                                        minimumFractionDigits: 2,
                                    })}</td>
                                </tr>
                            ))}
                        </tbody>
                        {summerizedResult.length > 0 ? <tfoot>
                            <tr>
                                <td colSpan={3} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total</td>
                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}> {Math.abs(summerizedResult.reduce((a, b) => +a + +(b.debit), 0).toFixed(txnDecimalAmt)).toLocaleString(undefined, {
                                    maximumFractionDigits: txnDecimalAmt,
                                    minimumFractionDigits: 2,
                                })}</td>
                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}> {Math.abs(summerizedResult.reduce((a, b) => +a + +(b.credit), 0).toFixed(txnDecimalAmt)).toLocaleString(undefined, {
                                    maximumFractionDigits: txnDecimalAmt,
                                    minimumFractionDigits: 2,
                                })}</td>
                            </tr>
                        </tfoot> : null}
                    </table>
                </Col>
            </Row>
            <Row>
                <ReactPaginate
                    previousLabel={'Previous'}
                    nextLabel={'Next'}
                    breakLabel={'...'}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    pageCount={Math.ceil(summerizedResult.length / 10)}
                    pageRangeDisplayed={1}
                    onPageChange={handleLedgerSummaryPageClick}
                    forcePage={ledgerSummaryPage - 1}
                    renderOnZeroPageCount={null}
                    activeClassName={'active'}
                    activeLinkClassName={'page-link'}
                    containerClassName={'pagination justify-content-end pagination-sm'}
                    marginPagesDisplayed={1}

                />
            </Row>
        </div>
    )

}